var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.appId > 3)?_c('orders'):_c('orders3')
}
var staticRenderFns = []

export { render, staticRenderFns }